import { createContext, useContext, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { LEXIQUE_TERMS } from "@/lib/lexique";

const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const PHRASES = LEXIQUE_TERMS.map((t) => ({
  slug: t.slug,
  re: new RegExp(`(^|[^\\p{L}])(${escapeRe(t.term)}s?)(?=[^\\p{L}]|$)`, "iu"),
})).sort((a, b) => b.re.source.length - a.re.source.length);

const LexLinkCtx = createContext(null);

export const LexLinkScope = ({ children }) => {
  const store = useMemo(() => new Set(), []);
  return <LexLinkCtx.Provider value={store}>{children}</LexLinkCtx.Provider>;
};

function buildNodes(text, selfSlug, used) {
  const out = [];
  let rest = text;
  let k = 0;
  while (rest) {
    let best = null;
    for (const p of PHRASES) {
      if (used.has(p.slug) || p.slug === selfSlug) continue;
      const m = rest.match(p.re);
      if (m) {
        const index = m.index + m[1].length;
        if (!best || index < best.index) best = { index, text: m[2], slug: p.slug };
      }
    }
    if (!best) {
      out.push(rest);
      break;
    }
    if (best.index > 0) out.push(rest.slice(0, best.index));
    out.push(
      <Link
        key={k++}
        to={`/lexique-sculpture/${best.slug}`}
        data-testid={`lexlink-${best.slug}`}
        className="underline decoration-bronze/50 decoration-1 underline-offset-4 transition-colors hover:text-bronze hover:decoration-bronze"
      >
        {best.text}
      </Link>
    );
    used.add(best.slug);
    rest = rest.slice(best.index + best.text.length);
  }
  return out;
}

export const RichText = ({ text }) => {
  const { pathname } = useLocation();
  const selfSlug = pathname.startsWith("/lexique-sculpture/") ? pathname.split("/")[2] : null;
  const shared = useContext(LexLinkCtx);
  const local = useMemo(() => new Set(), []);
  const used = shared || local;
  return useMemo(() => buildNodes(text, selfSlug, used), [text, selfSlug, used]);
};
